export default __webpack_public_path__ + "static/media/search-no-results.e432b503.png";